import { Navigate, Route, Routes } from "react-router-dom";
import { DashboardModuleProps } from "./types";
import DashboardModulePage from "./DashboardModulePage";
import ApplicationTemplate from "./Structure/ApplicationTemplate/ApplicationTemplate";
import { useEffect } from "react";

const DashboardModule: React.FC<DashboardModuleProps> = ({ module, sidePanelExt, customPages }) => {
	return (
		<ApplicationTemplate menuTabs={module.tabs} sidePanelExt={sidePanelExt}>
			<>
				{module?.defaultPage && (
					<>
						<Routes>
							<Route path={"*"} element={<Navigate to={module.defaultPage} />} />
							{customPages && customPages.map((m, index) => <Route key={index} path={"/" + m.path} element={m.content}></Route>)}
							{module.pages?.map((page) => page.path?.map((path) => <Route key={page.id} path={"/" + path} element={<DashboardModulePage key={page.id} pageParam={page} />}></Route>))}
						</Routes>
					</>
				)}
				{!module?.defaultPage && <h1>Error: Module has no default page</h1>}
			</>
		</ApplicationTemplate>
	);
};

export default DashboardModule;
